/**
 * Alert 형 모달 — Figma 디자인 시스템의 "Alert" 패턴.
 *
 * 케이스:
 *  - 안내 (1버튼): primaryAction만 (예: "재고 소진" + "확인")
 *  - 확인 (2버튼): primaryAction + secondaryAction (예: "취소할까요?" + 닫기/취소하기)
 *
 * primaryAction.variant:
 *  - 'default' = 검정 (#1B1C1D) — 기본 안내·등록·확인
 *  - 'danger'  = 빨강 (#EF4444) — 취소·삭제 같이 되돌릴 수 없는 액션
 *
 * Type B (시간 만료 Dialog, r-24, Bold title)는 별도 DialogModal로 분리 — 추후 작업.
 */

import { Modal } from '@onl-web/shared/components'

import type { AlertPrimaryVariant } from './styles'
import {
  AlertActions,
  AlertBackdrop,
  AlertContent,
  AlertDescription,
  AlertPrimaryButton,
  AlertSecondaryButton,
  AlertTextArea,
  AlertTitle,
} from './styles'

interface AlertAction {
  label: string
  onClick: () => void
}

interface AlertPrimaryActionProp extends AlertAction {
  variant?: AlertPrimaryVariant
}

interface AlertModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  description?: string
  primaryAction: AlertPrimaryActionProp
  secondaryAction?: AlertAction
}

export function AlertModal({ isOpen, onClose, title, description, primaryAction, secondaryAction }: AlertModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
    >
      <AlertBackdrop>
        <AlertContent>
          <AlertTextArea>
            <AlertTitle>{title}</AlertTitle>
            {description && <AlertDescription>{description}</AlertDescription>}
          </AlertTextArea>
          <AlertActions>
            {secondaryAction && (
              <AlertSecondaryButton
                type='button'
                onClick={secondaryAction.onClick}
              >
                {secondaryAction.label}
              </AlertSecondaryButton>
            )}
            <AlertPrimaryButton
              type='button'
              variant={primaryAction.variant ?? 'default'}
              onClick={primaryAction.onClick}
            >
              {primaryAction.label}
            </AlertPrimaryButton>
          </AlertActions>
        </AlertContent>
      </AlertBackdrop>
    </Modal>
  )
}
